<!--
 * @Author: your name
 * @Date: 2020-07-20 17:51:32
 * @LastEditTime: 2020-08-15 17:13:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\components\MaintainItem.vue
-->
<template>
    <div style="padding: 10px;font-size:0.35rem" @click="$emit('onItemClick', JSON.parse(JSON.stringify(item)))">
        <!-- <van-row style="margin: 5px">
            <van-col span="2"><van-tag type="success" size="large">{{ index + 1 }}</van-tag></van-col>
            <van-col span="8">
                <span class="info-span" style="font-size: 0.45rem; color: blue">{{ convertStatus(item.enumQualityInspectionResult) }}</span>
            </van-col>
            <van-col span="8"><span class="info-span" style="font-size: 0.35rem;">{{ item.maintainItem }}</span></van-col>
            <van-col span="4"><span class="info-span" style="font-size: 0.35rem;">{{ item.workHour }}</span></van-col>
            <van-col span="2"><van-icon name="arrow" size="20" @click="$emit('onItemClick', JSON.parse(JSON.stringify(item)))" /></van-col>
        </van-row>
        <van-row style="margin: 5px">
            <van-col span="8" offset="2"><span class="info-span" style="font-size: 0.35rem;">{{ item.position?item.position:'' }}</span></van-col>
            <van-col span="8"><span class="info-span" style="font-size: 0.35rem;">{{ item.part?item.part:'' }}</span></van-col>
            <van-col span="6"><span class="info-span" style="font-size: 0.35rem;">{{ convertReasonStatus(item.enumFaultReason) }}</span></van-col>
        </van-row>
        <van-row style="margin: 5px">
            <van-col span="8" offset="2"><span class="info-span" style="font-size: 0.35rem;">{{ item.teamName }}</span></van-col>
            <van-col span="8"><span class="info-span" style="font-size: 0.35rem;">{{ orderMenSplit(item.workOrderMen || item.statementMen) }}</span></van-col>
            <van-col span="6"><span class="info-span" style="font-size: 0.35rem;">{{ item.totalPrice?Number(item.totalPrice).toFixed(2):'' }}</span></van-col>
        </van-row> -->
        <van-row>
            <div style='display:flex;justify-content: space-between;'>
                <div style='display:flex;'>
                    <p style='border-radius:5px;display:inline-flex;margin-left:20px;
                        font-size:10px;
                        margin-top:3px;
                        text-align: center;
                        line-height: 26px;
                        width:26px;height:26px;display:flex; 
                        justify-content: center;
                        align-items: center;
                        background:#00CC99;'>{{ index+1 }}</p>
                    <span style='font-size:12px;line-height:30px;font-weight: 700;'>维修类型：{{ item.maintenTypeName }}</span>
                </div>
                <p style='color:#1890FF; margin-right:4vw; font-size:26px;margin-top:-3px;'>{{ item.maintainItemNum }}</p>
            </div>
            
            <div  styel=' margin-left:20px;'>
                <span style='font-size:12px;margin-left:13vw; font-weight: 700;'>维修项目：{{ item.maintainItem }}</span>
            </div>
            <!-- <p>
                <span style="font-size:16px">{{ item.workHour }}</span>
                <span  style="font-size:16px">{{ item.unitPrice }}</span>
            </p> -->
            <p>
                <span  style="font-size:12px;width:25%;margin-left:13vw;">维修队：{{ item.teamName }}</span>
            </p>
            <p style='border-bottom:1px solid #ccc;'>
                <span style="font-size:12px;width:25%;margin-left:13vw;">工位：{{ item.stationName}}</span>
                <span  style="font-size:12px;width:20%;margin-left:13vw;">{{ item.totalPrice }}元</span>
            </p>
            <p>
                <span  style="width:40%">{{ item.workerNames }}</span>
            </p>
        </van-row>
    </div>
</template>

<script>
export default {
    name: 'MaintainItem',
    props: {
        index: {
            type: Number,
            default: 0
        },
        item: {
            type: Object,
            default: null
        },
        enumWorkOrderType: {
            type: Number,
            default: 0
        },
        formData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            itemData: null
        }
    },
    created() {
        if (this.formData.isOnlyRequisitionPart) {
            this.item.enumQualityInspectionResult = 2
        }
    },
    methods: {
        convertStatus(status) {
            switch (status) {
            case 0:
                return '未质检'
            case 1:
                return '未质检'
            case 2:
                return '质检通过'
            case 3:
                return '质检不通过'
            case 4:
                return '客户终止'
            case 5:
                return '不需维修'
            case 6:
                return '缺件'
            }
        },
        convertReasonStatus(status) {
            switch (status) {
            case 0:
                return ''
            case 1:
                return '自然损坏'
            case 2:
                return '驾驶操作'
            case 3:
                return '配件质量'
            case 4:
                return '维修装配'
            }
        },
        orderMenSplit(items) {
            console.log(items)
            return items.map(item => {
                return item.workerName
            }).join(',')
        }
    }
}
</script>

<style lang='scss' scoped>
.info-span{
    padding: 10px 20px;
    color:#000;
    font-size: 15px;
    display:inline-block;
    width:100%;
     overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
</style>
